import React from "react";
import PropTypes from "prop-types";
import "./public-lead.css";

export function formatPhone(phone) {
  if (!phone) return "";
  const cleaned = ("" + phone).replace(/\D/g, "");
  const lastTen = cleaned.slice(-10);
  const match = lastTen.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) return `(${match[1]}) ${match[2]}-${match[3]}`;
  return phone;
}

export function agentInitials(first, last) {
  const letters = `${first || ""} ${last || ""}`
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0))
    .join("")
    .toUpperCase();
  return letters || "RS";
}

function PhoneIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.7.7a2 2 0 0 1 1.7 2z" />
    </svg>
  );
}

function MailIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 7l9 6 9-6" />
    </svg>
  );
}

export function PublicHeader({ logoSrc, projectLogo }) {
  return (
    <header className="rs-header">
      <div className="rs-header-inner">
        {logoSrc ? (
          <img className="rs-broker-logo" src={logoSrc} alt="" />
        ) : (
          <div className="rs-logo-placeholder">Brokerage logo</div>
        )}
        <div className="rs-header-right">
          <div className="rs-powered"></div>
          {projectLogo ? (
            <img className="rs-project-logo-sm" src={projectLogo} alt="" />
          ) : null}
        </div>
      </div>
    </header>
  );
}

PublicHeader.propTypes = {
  logoSrc: PropTypes.string,
  projectLogo: PropTypes.string,
};

export function PublicFooter() {
  return <div className="rs-footer">Powered by Realty Space</div>;
}

export function AgentCard({ label, firstName, lastName, phone, email, showActions }) {
  const name = [firstName, lastName].filter(Boolean).join(" ") || "Your agent";
  const phoneText = formatPhone(phone);
  const tel = phone ? String(phone).replace(/[^\d+]/g, "") : "";
  return (
    <div className="rs-agent">
      <div className="rs-avatar" aria-hidden="true">
        {agentInitials(firstName, lastName)}
      </div>
      <div className="rs-agent-copy">
        <div className="eyebrow">{label}</div>
        <div className="name">{name}</div>
        {(phoneText || email) && (
          <div className="sub">
            {phoneText}
            {phoneText && email ? " · " : ""}
            {email}
          </div>
        )}
      </div>
     
    </div>
  );
}

AgentCard.propTypes = {
  label: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  phone: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  email: PropTypes.string,
  showActions: PropTypes.bool,
};

export function PinIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#F5B83D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flex: "none", marginTop: 3 }}>
      <path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z" />
      <circle cx="12" cy="9.5" r="2.5" />
    </svg>
  );
}

export function CalendarIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M16 3v4M8 3v4M3 10h18" />
    </svg>
  );
}

export function PlaceIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M21 10c0 6-9 12-9 12s-9-6-9-12a9 9 0 1 1 18 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );
}
